import { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import { useTheme } from '@mui/material/styles';
import {
  Button,
  DialogActions,
  DialogContent,
  DialogContentText,
  Typography
} from '@mui/material';
import { useAppSelector } from 'hooks/useAppStore';
import { selectAjaxLoader } from 'features/app/appSelectors';

export interface ConfirmationDialogContentProps {
  onSubmit: () => void;
  onClose: () => void;
  submitButtonTitle?: string;
  cancelButtonTitle?: string;
  description: string;
  description2?: string;
  disabled?: boolean;
}

// ===============================|| CONFIRMATION DIALOG CONTENT ||=============================== //

const ConfirmationDialogContent = (
  props: ConfirmationDialogContentProps
): ReactElement => {
  const theme = useTheme();
  const { t } = useTranslation();

  const operationInProgress = useAppSelector(selectAjaxLoader);

  const {
    onSubmit,
    onClose,
    submitButtonTitle,
    cancelButtonTitle,
    description,
    description2,
    disabled
  } = props;

  const handleSubmit = (): void => {
    onSubmit();
  };

  const disableButtons = operationInProgress || disabled;
  const cancelButtonStyle = !cancelButtonTitle
    ? {
        color: theme.palette.error.dark,
        borderColor: theme.palette.error.dark
      }
    : {};

  return (
    <>
      <DialogContent>
        <DialogContentText id='confirmation-dialog-description'>
          <Typography variant='body2' component='span'>
            {t(description)}
            {!!description2 && description2}
          </Typography>
        </DialogContentText>
      </DialogContent>
      <DialogActions sx={{ pr: 2.5 }}>
        <Button
          sx={cancelButtonStyle}
          onClick={onClose}
          disabled={disableButtons}
          color='primary'
        >
          {t(cancelButtonTitle ?? 'common.button.cancel')}
        </Button>
        <Button
          variant='contained'
          size='medium'
          onClick={handleSubmit}
          disabled={disableButtons}
          autoFocus
        >
          {t(submitButtonTitle ?? 'common.button.saveChanges')}
        </Button>
      </DialogActions>
    </>
  );
};

export default ConfirmationDialogContent;
